import { BadgeCheck, UserCheck, Crosshair, SlidersHorizontal } from "lucide-react";
import { Container, Section, Eyebrow, Reveal } from "@/components/kit";

const qualifiers = [
  {
    icon: BadgeCheck,
    title: "Qualified",
    desc: "Every meeting clears budget, authority, need and timeline gates before it ever hits your calendar.",
  },
  {
    icon: UserCheck,
    title: "Attended",
    desc: "No-shows don't count. You're only billed for meetings the prospect actually shows up to.",
  },
  {
    icon: Crosshair,
    title: "ICP-Matched",
    desc: "Firmographics, tech stack and buying signals are verified against your exact ideal customer profile.",
  },
  {
    icon: SlidersHorizontal,
    title: "Parameter-Aligned",
    desc: "Region, company size, role and use-case all match the parameters we mutually agree on up front.",
  },
];

export const Qualifiers = () => (
  <Section data-testid="qualifiers-section">
    <Container>
      <div className="max-w-3xl">
        <Eyebrow>The Pay-For-Performance Model</Eyebrow>
        <h2 className="mt-6 font-display text-3xl md:text-4xl lg:text-5xl font-medium tracking-tight text-white">
          We don't charge for meetings.
          <br />
          <span className="text-white/45">We charge for meetings that count.</span>
        </h2>
        <p className="mt-6 text-white/60 text-base md:text-lg leading-relaxed">
          A booking isn't a result. A qualified meeting is. Every meeting must pass all four gates
          below — or it's on us.
        </p>
      </div>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {qualifiers.map((q, i) => (
          <Reveal key={q.title} delay={i * 0.08}>
            <div className="group relative h-full overflow-hidden rounded-2xl border border-white/10 bg-navy-800 p-8 transition-[border-color,box-shadow,transform] duration-300 hover:-translate-y-2 hover:border-gold/50 hover:shadow-[0_0_40px_rgba(255,215,0,0.12)]">
              <span className="absolute right-6 top-6 font-mono-jb text-xs text-white/25">
                0{i + 1}
              </span>
              <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-gold/10 border border-gold/25 text-gold transition-colors duration-300 group-hover:bg-gold group-hover:text-navy-900">
                <q.icon className="h-6 w-6" />
              </div>
              <h3 className="mt-6 font-display text-xl font-semibold text-white">{q.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-white/55">{q.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </Container>
  </Section>
);
